<div style="border-left: 5px solid rgb(207, 121, 1);border-right: 5px solid rgb(207, 121, 1);  font-size: 12px;">
    <div class="backgroundTela">
        &nbsp;
    </div>
    <mat-tab-group [selectedIndex]="selectedIndex" animationDuration="100ms" style=" margin-left: 5px;">
        <mat-tab *ngFor="let number of [0];let i=index;" label="🗑️ Exclusões Pendentes">

            <!--Definir o tamanho da tela-->
            <div style=" width: 100%; overflow:hidden; text-align: center; ">
                <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">
                    <table style="width: 98%; margin-left: 10px; ">
                        <tr>
                            <td style="width: 100%;"> &nbsp;
                            </td>
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;
                </div>
            </div>

            <div id="divContainer" style="margin-top: 15px; ">
                <div id="divAdjustAutoHeight">
                    <div style="margin-left: 5px; margin-right: 5px;">

                        <!--container ajustado dinamicamente-->
                        <div id="formAndList" style="margin-left: 10px;">
                            <div
                                style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                <div style=" margin-left: 15px; font-size: 14px;">Solicitações de Exclusões Pendentes
                                </div>
                            </div>
                            <div
                                style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">
                                &nbsp;
                            </div>


                            <mat-card class="mat-elevation-z8" style="padding: 8px; overflow-y: hidden;">

                                <!--container ajustado dinamicamente-->
                                <div id="formAndList" style="width: 100%; ">
                                    <div  style="overflow-x: hidden; font-size: 12px;">
                                        <div style="width: 98%; margin-top: 5px; margin-left: 5px;">
                                            <mat-form-field class="example-full-width">
                                                <mat-label>Buscar na lista </mat-label>
                                                <input matInput (keyup)="applyFilter($event)"
                                                    placeholder="Digite a busca de qualquer item na lista abaixo..."
                                                    #input>
                                            </mat-form-field>
                                        </div>

                                        <!--container ajustado dinamicamente-->
                                        <div id="subDivContainer" style="width: 100%; ">
                                            <div id="subDivAdjustAutoHeight" style="overflow-y: auto; overflow-x: hidden;">

                                                <ng-container *ngIf="monitoryExclusions$.data.length > 0; else emptyListHistory">
                                                    <table mat-table [dataSource]="monitoryExclusions$" class="mat-elevation-z8"
                                                        style="width: 100%;  margin-left: 7px; margin-bottom: 3px;  ">

                                                        <!-- Position Column -->
                                                        <ng-container matColumnDef="moniIdCdMonitoria">
                                                            <th mat-header-cell *matHeaderCellDef style="width:10%;"> Cód.
                                                                Monitoria
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                style="width:10%; cursor: pointer;">
                                                                {{element.moniIdCdMonitoria}} </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="formDsFormulario">
                                                            <th mat-header-cell *matHeaderCellDef style="width:18%;"> Formulário
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                style="width:18%; cursor: pointer;">
                                                                {{element.formDsFormulario}} </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="exmoDsMotivo">
                                                            <th mat-header-cell *matHeaderCellDef style="width:18%;"> Motivo
                                                                Exclusão
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                style="width:18%; cursor: pointer;">
                                                                {{element.exmoDsMotivo}} </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="usuaNmUsuario">
                                                            <th mat-header-cell *matHeaderCellDef style="width:18%;"> Usuário
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                style="width:18%; cursor: pointer;">
                                                                {{element.usuaNmUsuario}} </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="operNmOperacao">
                                                            <th mat-header-cell *matHeaderCellDef style="width:18%;"> Operação
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                style="width:18%; cursor: pointer;">
                                                                {{element.operNmOperacao}} </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="edit">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="width:18%; text-align: center;"> Ações
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                style="width:18%; cursor: pointer; text-align: center;">
                                                                <input (click)="update(element, 'A')" type="image"
                                                                    class="imgBtn"
                                                                    src="../../../assets/img/icones/aprovar.png" />
                                                                <input style="margin-left: 10px;" (click)="update(element, 'R')"
                                                                    type="image" class="imgBtn"
                                                                    src="../../../assets/img/icones/excluir.png" />
                                                                <input style="margin-left: 10px;" (click)="detailRow(element.moniIdCdMonitoria)"
                                                                    type="image" class="imgBtn"
                                                                    src="../../../assets/img/icones/abrirDialog.png" />
                                                            </td>
                                                        </ng-container>

                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"
                                                            style="height: 15px;"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns; "
                                                            class="aoPassarMouse" style="height: 10px click; "></tr>
                                                    </table>
                                                </ng-container>

                                                <ng-template #emptyListHistory>
                                                    <table class="mat-table" class="mat-elevation-z8"
                                                        style="width: 98%;  margin-left: 7px;margin-bottom: 3px; ">
                                                        <thead>
                                                            <tr>
                                                                <th class="mat-header-cell"> Cód. Monitoria </th>
                                                                <th class="mat-header-cell"> Formulário </th>
                                                                <th class="mat-header-cell"> Motivo Exclusão </th>
                                                                <th class="mat-header-cell"> Usuário </th>
                                                                <th class="mat-header-cell"> Operação </th>
                                                                <th class="mat-header-cell"> Ações </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="tg-0lax" colspan="6"
                                                                    style="text-align: center; align-content: center; padding: 5px;">
                                                                    Nenhuma solicitação de
                                                                    exclusão disponível.</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </ng-template>

                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </mat-card>
                              
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab *ngFor="let number of [1];let i=index;" label="" disabled>&nbsp;</mat-tab>
    </mat-tab-group>
</div>